import type { Topic } from "../entities/Topic";
import {
    downloadTextAsFile,
    markdownFilenameFromTitle,
} from "../../../utils/downloadTextFile";
import { buildTopicMarkdown } from "./copyTopicContentUseCase";

export const downloadTopicContentUseCase = {
    async exec(topic: Topic): Promise<void> {
        const content = await buildTopicMarkdown(topic);
        if (!content) return;

        downloadTextAsFile(
            content,
            markdownFilenameFromTitle(topic.title, "topic"),
        );
    },
};
